import React, { useContext } from 'react';
import AppContext from '../context/Context';
import FinanceRoutes from '../routes/FinanceRoutes';

const FinanceLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <FinanceRoutes />
            </div>
}

export default FinanceLayout;